import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import ProductCategoryService from "services/ProductCategoryService";
export const initialState = {
  data: [],
  dataSelect: [],
  dataDetail: [],
  dataDelete: null,
  loading: false,
  error: null,
  redirect: false,
};

export const fetchCategoryData = createAsyncThunk(
  "category/fetchCategoryData",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, searchText, state } = data;
      const response = await ProductCategoryService.get({
        page,
        pageSize,
        sort,
        searchText,
        state,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchCategoryDataSelect = createAsyncThunk(
  "category/fetchCategoryDataSelect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ProductCategoryService.getSelect();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchCategoryDetail = createAsyncThunk(
  "category/fetchCategoryDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ProductCategoryService.getById(id);
      // if (response.status === 404)
      //   return rejectWithValue(response.data?.detail || "Error");
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const createCategoryData = createAsyncThunk(
  "category/createCategoryData",
  async (data, { rejectWithValue }) => {
    try {
      const { name } = data;
      const response = await ProductCategoryService.createCategory({
        name,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const updateCategoryData = createAsyncThunk(
  "category/updateCategoryData",
  async (data, { rejectWithValue }) => {
    try {
      const { id, name } = data;
      const response = await ProductCategoryService.updateCategory({
        id,
        name,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const deleteCategoryData = createAsyncThunk(
  "category/deleteCategoryData",
  async (data, { rejectWithValue }) => {
    try {
      const { id, confirm } = data;
      const response = await ProductCategoryService.deleteCategory(id, confirm);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    resetDataDeleteCategory: (state) => {
      state.dataDelete = null;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(fetchCategoryData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchCategoryData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchCategoryDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategoryDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDetail = action.payload.data;
        state.error = null;
      })
      .addCase(fetchCategoryDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCategoryData.pending, (state) => {
        state.loading = true;
        state.redirect = false;
      })
      .addCase(createCategoryData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(createCategoryData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCategoryData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCategoryData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(updateCategoryData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteCategoryData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(deleteCategoryData.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status === 200) state.dataDelete = action.payload;
        else {
          state.redirect = true;
          notification.success({ message: "Proses Berhasil" });
        }
      })
      .addCase(deleteCategoryData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCategoryDataSelect.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategoryDataSelect.fulfilled, (state, action) => {
        state.loading = false;
        state.dataSelect = action.payload.data.data;
      })
      .addCase(fetchCategoryDataSelect.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { showLoading, resetDataDeleteCategory } = categorySlice.actions;

export default categorySlice.reducer;
